import { z } from "@reflag/shared/utils/zod";

export const redirectUrlSchema = z
  .string()
  .regex(/^\/(?:[^/]|$)/, "Redirect path must be root-relative");
